import React from 'react';
import styled from 'styled-components';
import { AdZoneIdMap } from './ads-zone-id-map';
import { AdsBannerInsTag } from './ads-banner-ins-tag';

export const UndergroundContainer = styled.div<{
  background: string | undefined;
}>(({ theme, background }) =>
  theme.withMedia({
    display: 'inline-block',
    backgroundImage: background,
    backgroundRepeat: 'no-repeat',
    border: '1px solid transparent',
    borderRadius: '6px',

    ...(background && { cursor: 'pointer' }),

    img: {
      border: '0px solid transparent',
      borderRadius: '6px',
    },
  })
);

export const DesktopUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '300px',
      height: '100px',
      margin: '0',
      backgroundSize: '300px 100px',
    })
);

export const TabletUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '728px',
      height: '90px',
      backgroundSize: '728px 90px',
    })
);

export const MobileUndergroundContainer = styled(UndergroundContainer)(
  ({ theme }) =>
    theme.withMedia({
      width: '300px',
      height: '100px',
      backgroundSize: '300px 100px',
    })
);

const UndergroundAdsBannerContainer = ({ children, screenType }) => {
  const onPlaceholderClick = () => {
    const hasInsTagWithLink = document.querySelector('ins > a');

    if (!(hasInsTagWithLink && hasInsTagWithLink.hasAttribute('href'))) {
      window.open('https://cspr.live/activity-export', '_blank');
    }
  };

  const getBackgroundContainerByScreenType = () => {
    switch (screenType) {
      case 'mobile':
        return (
          <MobileUndergroundContainer
            background={`url('/assets/images/ad-activity-export-short.webp?v=2')`}
            onClick={onPlaceholderClick}
          >
            {children}
          </MobileUndergroundContainer>
        );
      case 'tablet':
        return (
          <TabletUndergroundContainer
            background={`url('/assets/images/ad-activity-export-long.webp?v=2')`}
            onClick={onPlaceholderClick}
          >
            {children}
          </TabletUndergroundContainer>
        );
      default:
        return (
          <DesktopUndergroundContainer
            background={`url('/assets/images/ad-activity-export-short.webp?v=2')`}
            onClick={onPlaceholderClick}
          >
            {children}
          </DesktopUndergroundContainer>
        );
    }
  };

  return getBackgroundContainerByScreenType();
};

const AdsBanner = ({
  pageCode,
  screenType,
}: {
  pageCode: string;
  screenType?: string;
}) => {
  const networkName = config.network_name;
  const env = config.environment_name;
  const envByNetworkVersion = networkName === 'dev-net' ? 'testnet' : env;

  const zonesIdsByPage = AdZoneIdMap[pageCode].banner;
  const zoneId = zonesIdsByPage[screenType][envByNetworkVersion];

  return (
    <UndergroundAdsBannerContainer screenType={screenType}>
      <AdsBannerInsTag zoneId={zoneId} />
    </UndergroundAdsBannerContainer>
  );
};

export default AdsBanner;
